<template src="./template.html"></template>

<script>
import TENKENGYOUMU_BASE from 'src/consts/tenkengyoumu_base'
import masterMixin from 'src/mixins/masterMixin'
import notificationMixin from 'src/mixins/notificationMixin'
import imageMixin from 'src/mixins/imageMixin'
import poleMixin from 'src/mixins/poleMixin'
import tenkenDataBaseApi from 'src/apis/tenken_data_base'

export default {
  displayPageName: '結果入力',
  data() {
    const now = new Date()
    now.setHours(0, 0, 0, 0)
    return {
      today: now,

      search: {},
      selectedFiles: [],
      selectedFolderName: '',

      tdbs: [],
      saveCandidate: {},

      showSearchResult: false,
      showCreateModal: false,
      showBulkCreateModal: false,
      showBulkUpdateModal: false,
      showBulkDeleteModal: false,

      kanriStaffCands: [],
      sekininStaffCands: [],
      tenkenStaffCands: [],
      tenkenStaffMap: {},
      origUkeoigyoushaCands: [],
      weatherCands: [],
      kijiCands: [],
      origRosenCands: [],
      rosenMap: {},

      pagination: {
        currentPage: 1,
        itemsPerPage: 50,
      },

      isRequesting: false,
    }
  },
  computed: {
    paginatedList() {
      const nextPageIdx = this.pagination.currentPage * this.pagination.itemsPerPage
      const minIdx = nextPageIdx - this.pagination.itemsPerPage
      return this.tdbs.filter((e, i) => {
        return i >= minIdx && i < nextPageIdx
      })
    },
    hasList() {
      return this.tdbs.length > 0
    },
    hasSavedList() {
      return this.tdbs.filter(e => !e.isUnsaved).length > 0
    },
    hasSelectedUnsavedList() {
      return this.tdbs.filter(e => e.isSelected && e.isUnsaved).length > 0
    },
    selectedNum() {
      return this.tdbs.filter(e => e.isSelected).length
    },
    selectedUnsavedNum() {
      return this.tdbs.filter(e => e.isSelected && e.isUnsaved).length
    },
    showRosenKukan() {
      const rosen = this.rosenMap[this.saveCandidate.rosen_id]
      if (!rosen) { return false }
      return rosen.kaishi_kukan || rosen.shuuryou_kukan
    },
    ukeoigyoushaCands() {
      return this.filterByTenkenDate(this.origUkeoigyoushaCands)
    },
    rosenCands() {
      return this.filterByTenkenDate(this.origRosenCands)
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    this.prepareMasters()
    this.prepareSearchParams()
    this.doSearch()
  },
  mixins: [masterMixin, notificationMixin, imageMixin, poleMixin],
  methods: {
    filterByTenkenDate(items) {
      const dt = new Date(this.search.tenkenDate)
      return items.filter(e => {
        const startDt = new Date(e.start_date)
        const endDt = new Date(new Date(e.end_date).valueOf() + 86400 * 1000)
        return (startDt <= dt) && (dt < endDt)
      })
    },
    prepareMasters() {
      const master = window.master
      const staffCands = master.staff.vals.filter(e => e.is_valid)
      // 管理技術者
      this.kanriStaffCands = staffCands.filter(e => e.is_kanri)
      // 点検責任者
      this.sekininStaffCands = staffCands.filter(e => e.is_sekinin)
      // 点検員
      this.tenkenStaffCands = staffCands.filter(e => e.is_tenken || e.is_shunin)
      this.tenkenStaffMap = this.tenkenStaffCands.reduce((acc, e) => {
        acc[e.m_staff_id] = e; return acc
      }, {})
      // 受注者
      this.origUkeoigyoushaCands = master.ukeoigyousha.vals
      // 天候
      this.weatherCands = master.weather.vals
      // 記事
      this.kijiCands = master.kiji.vals
      // 路線
      this.origRosenCands = master.rosen.vals
      this.rosenMap = this.origRosenCands.reduce((acc, e) => {
        acc[e.m_rosen_id] = e; return acc
      }, {})
    },
    prepareSearchParams() {
      const search = {}
      const query = this.$route.query
      // 点検年月日
      search.tenkenDate = query.tenken_date || this.today
      // 点検員
      let tenkeninId = null
      if (this.tenkenStaffCands.length > 0) {
        tenkeninId = this.tenkenStaffCands[0].m_staff_id
      }
      search.tenkeninId = query.tenkenin_id || tenkeninId

      this.search = search
    },
    resetSearchResults() {
      this.tdbs = []
      this.saveCandidate = {}
      if (
        this.$refs.commons &&
        this.$refs.rosen
      ) {
        this.$refs.commons.reset()
        this.$refs.rosen.reset()
      }
      this.pagination.currentPage = 1
    },
    getNewTenkenDataBase() {
      const ukeoigyousha = this.ukeoigyoushaCands.length > 0 ? this.ukeoigyoushaCands[0] : {}
      const obj = {
        tenken_gyoumu_id: TENKENGYOUMU_BASE.ROKA,
        tenken_date: this.search.tenkenDate,
        tenkenin_id: this.search.tenkeninId,
        weather_id: '',
        start_time: '',
        start_time_h: '',
        start_time_m: '',
        end_time: '',
        end_time_h: '',
        end_time_m: '',
        kanri_gijutsusha_id: '',
        ukeoigyousha_id: ukeoigyousha.m_ukeoigyousha_id || '',
        tenken_sekininsha_id: '',
        kiji_id: '',
        rosen_id: '',
      }

      const savedItems = this.tdbs.filter(e => !e.isUnsaved)
      if (savedItems.length > 0) {
        // 登録済み点検結果がある場合は、共通項目をコピー
        const origObj = savedItems[0]
        const props = [
          'weather_id',
          'start_time',
          'end_time',
          'kanri_gijutsusha_id',
          'ukeoigyousha_id',
          'tenken_sekininsha_id',
          'kiji_id',
        ]
        props.forEach(prop => {
          obj[prop] = origObj[prop]
        })

        // 開始時刻を時・分に分解する
        if (obj.start_time) {
          const hm = obj.start_time.split(':')
          obj.start_time_h = hm[0]
          obj.start_time_m = hm[1]
        }
        // 終了時刻を時・分に分解する
        if (obj.end_time) {
          const hm = obj.end_time.split(':')
          obj.end_time_h = hm[0]
          obj.end_time_m = hm[1]
        }
      }

      return obj
    },
    async addTenkenDataBaseByPhotoGeoInfo() {
      if (!this.selectedFiles || this.selectedFiles.length === 0) {
        return
      }

      const usedRosenIds = this.tdbs.map(e => e.rosen_id)
      const availableRosenCands = this.rosenCands
        .filter(e => usedRosenIds.findIndex(id => id === e.m_rosen_id) === -1)
      const rosenIds = []
      for (const file of this.selectedFiles) {
        const src = window.URL.createObjectURL(file)
        const image = await this.loadImageWithExif(src)
        if (!image.exifdata) { continue }

        const { latitude, longitude } = this.getGeoInfoFromExif(image.exifdata)
        if (!latitude || !longitude) { continue }

        const pole = await this.getPoleByGeoInfo(latitude, longitude)
        if (!pole) { continue }

        const rosenList = availableRosenCands.filter(e => e.name_kodan === pole.route)
        rosenIds.push(...rosenList.map(e => e.m_rosen_id))
      }

      const uniqRosenIds = new Array(...new Set(rosenIds))
      uniqRosenIds.forEach(rosenId => {
        const tdb = {
          tenken_date: this.search.tenkenDate,
          tenkenin_id: this.search.tenkeninId,
          rosen_id: rosenId,
          isUnsaved: true,
        }
        this.tdbs.push(tdb)
      })
    },
    async doSearch() {
      if (this.isRequesting) { return }

      this.isRequesting = true
      try {
        this.showSearchResult = false
        await this._doSearch()
        await this.addTenkenDataBaseByPhotoGeoInfo()
        this.isRequesting = false
        this.showSearchResult = true
      } catch (err) {
        console.error('error', err)
        this.isRequesting = false
      }
    },
    async _doSearch() {
      this.resetSearchResults()
      try {
        const reqObj = {
          tenken_gyoumu_id: TENKENGYOUMU_BASE.ROKA,
          tenken_date: this.search.tenkenDate,
          tenkenin_id: this.search.tenkeninId,
        }
        const { data } = await tenkenDataBaseApi.index(reqObj)
        this.tdbs = data
        this.saveCandidate = this.getNewTenkenDataBase()
      } catch (err) {
        console.error('error', err)
      }
    },
    onFolderChange(evt) {
      this.selectedFiles = evt.target.files
      if (this.selectedFiles.length > 0) {
        let filepath = ''
        filepath = this.selectedFiles[0].webkitRelativePath
        const folderName = filepath.split('/')[0]
        this.selectedFolderName = folderName
      }
      this.showSearchResult = false
    },
    getTenkenDataBaseForReq(obj) {
      const ret = JSON.parse(JSON.stringify(obj))
      // 点検業務基本
      if (!ret.tenken_gyoumu_id) {
        ret.tenken_gyoumu_id = TENKENGYOUMU_BASE.ROKA
      }
      // 開始時刻
      const startHStr = ret.start_time_h
      const startMStr = ret.start_time_m
      let startTime = null
      if (!!startHStr && !!startMStr) {
        startTime = `${startHStr}:${startMStr}`
      }
      ret.start_time = startTime
      // 終了時刻
      const endHStr = ret.end_time_h
      const endMStr = ret.end_time_m
      let endTime = null
      if (!!endHStr && !!endMStr) {
        endTime = `${endHStr}:${endMStr}`
      }
      ret.end_time = endTime
      return ret
    },
    async openCreateModal() {
      const promises = [
        this.$refs.commons.validate(),
        this.$refs.rosen.validate(),
      ]
      const [isCommonsValid, isRosenValid] = await Promise.all(promises)
      if (!isCommonsValid || !isRosenValid) { return }

      this.showCreateModal = true
    },
    async createTenkenDataBase() {
      if (this.isRequesting) { return }

      this.isRequesting = true
      try {
        // 共通設定項目が変更されている場合は、先に登録済み点検結果を更新する
        if (this.$refs.commons && this.$refs.commons.flags.changed) {
          const saveCandidates = this.tdbs.filter(e => !e.isUnsaved).map(e => {
            const obj = JSON.parse(JSON.stringify(this.saveCandidate))
            obj.base_id = e.base_id
            return obj
          })
          await this._bulkUpdateTenkenDataBaseList(saveCandidates)
        }
        // 点検結果作成
        const reqObj = this.getTenkenDataBaseForReq(this.saveCandidate)
        await tenkenDataBaseApi.create(reqObj)
        const unsavedItems = this.tdbs.filter(e => e.isUnsaved)
        await this._doSearch()
        this.tdbs.push(...unsavedItems)
        this.showCreateModal = false
        this.notifySuccess1('点検結果を作成しました。')
        this.isRequesting = false
      } catch (err) {
        const msg = '点検結果の作成に失敗しました。' +
          '管理者にご連絡ください。'
        this.notifyError1(msg, { err })
        this.isRequesting = false
      }
    },
    async openBulkCreateModal() {
      const isValid = await this.$refs.commons.validate()
      if (!isValid) { return }

      this.showBulkCreateModal = true
    },
    async bulkCreateTenkenDataBaseList() {
      if (this.isRequesting) { return }

      this.isRequesting = true
      try {
        // 共通設定項目が変更されている場合は、先に登録済み点検結果を更新する
        if (this.$refs.commons && this.$refs.commons.flags.changed) {
          const saveCandidates = this.tdbs.filter(e => !e.isUnsaved).map(e => {
            const obj = JSON.parse(JSON.stringify(this.saveCandidate))
            obj.base_id = e.base_id
            return obj
          })
          await this._bulkUpdateTenkenDataBaseList(saveCandidates)
        }
        // 点検結果作成
        const saveCandidates = this.tdbs.filter(e => e.isSelected && e.isUnsaved).map(e => {
          const obj = JSON.parse(JSON.stringify(this.saveCandidate))
          obj.rosen_id = e.rosen_id
          return obj
        })
        for (const saveCandidate of saveCandidates) {
          const reqObj = this.getTenkenDataBaseForReq(saveCandidate)
          await tenkenDataBaseApi.create(reqObj)
        }
        const unsavedItems = this.tdbs.filter(e => e.isUnsaved && !e.isSelected)
        await this._doSearch()
        this.tdbs.push(...unsavedItems)
        this.showBulkCreateModal = false
        this.notifySuccess1('点検結果を登録しました。')
        this.isRequesting = false
      } catch (err) {
        const msg = '点検結果の登録に失敗しました。' +
          '管理者にご連絡ください。'
        this.notifyError1(msg, { err })
        this.isRequesting = false
      }
    },
    async openBulkUpdateModal() {
      const isValid = await this.$refs.commons.validate()
      if (!isValid) { return }

      this.showBulkUpdateModal = true
    },
    async bulkUpdateTenkenDataBaseList() {
      if (this.isRequesting) { return }

      this.isRequesting = true
      try {
        const saveCandidates = this.tdbs.filter(e => !e.isUnsaved).map(e => {
          const obj = JSON.parse(JSON.stringify(this.saveCandidate))
          obj.base_id = e.base_id
          return obj
        })
        await this._bulkUpdateTenkenDataBaseList(saveCandidates)
        const unsavedItems = this.tdbs.filter(e => e.isUnsaved)
        await this._doSearch()
        this.tdbs.push(...unsavedItems)
        this.showBulkUpdateModal = false
        this.notifySuccess1('共通設定項目を更新しました。')
        this.isRequesting = false
      } catch (err) {
        const msg = '共通設定項目の一括更新に失敗しました。' +
          '管理者にご連絡ください。'
        this.notifyError1(msg, { err })
        this.isRequesting = false
      }
    },
    async _bulkUpdateTenkenDataBaseList(items) {
      try {
        const promises = []
        items.forEach(e => {
          const reqObj = this.getTenkenDataBaseForReq(e)
          const prms = tenkenDataBaseApi.update(e.base_id, reqObj)
          promises.push(prms)
        })
        await Promise.all(promises)
      } catch (err) {
        console.error('error', err)
        throw err
      }
    },
    async bulkDeleteTenkenDataBaseList() {
      if (this.isRequesting) { return }

      this.isRequesting = true
      try {
        const items = this.tdbs.filter(e => e.isSelected && !e.isUnsaved)
        const promises = []
        items.forEach(e => {
          const prms = tenkenDataBaseApi.delete(e.base_id)
          promises.push(prms)
        })
        await Promise.all(promises)
        const unsavedItems = this.tdbs.filter(e => e.isUnsaved && !e.isSelected)
        await this._doSearch()
        this.tdbs.push(...unsavedItems)
        this.showBulkDeleteModal = false
        this.notifySuccess1('点検結果を削除しました。')
        this.isRequesting = false
      } catch (err) {
        const msg = '点検結果の削除に失敗しました。' +
          '管理者にご連絡ください。'
        this.notifyError1(msg, { err })
        this.isRequesting = false
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
